import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/avatars/blank.png"
  })
], -1)
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_7 = { class: "badge badge-light-info fw-bolder fs-8 px-2 py-1 ms-2" }
const _hoisted_8 = {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-7"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_10 = { class: "menu-item px-5" }
const _hoisted_11 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_12 = {
  type: "button",
  class: "menu-link px-5 border-0 bg-transparent w-100 text-start"
}
const _hoisted_13 = { class: "menu-title position-relative" }
const _hoisted_14 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_17 = { class: "menu-item px-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/united-states.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/kuwait.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_21 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.user.name) + " ", 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.user.role?.name), 1)
          ]),
          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.user.email.length > 20
                ? _ctx.user.email.slice(0, 18).concat('...')
                : _ctx.user.email), 1)
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_link, {
        to: _ctx.profilePageRoute,
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" My Profile ")
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, [
          _createTextVNode(" Language "),
          _createElementVNode("span", _hoisted_14, [
            _createTextVNode(_toDisplayString(_ctx.currentLangugeLocale.name) + " ", 1),
            _createElementVNode("img", {
              class: "w-15px h-15px rounded-1 ms-2",
              src: _ctx.currentLangugeLocale.flag,
              alt: "metronic"
            }, null, 8, _hoisted_15)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('en'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('en') }])
          }, [
            _hoisted_18,
            _createTextVNode(" English ")
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('ar'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('ar') }])
          }, [
            _hoisted_20,
            _createTextVNode(" العربية ")
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("a", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ]))
}